<template>
    <delete-student-form 
        v-if="deleteStudentFormFlag"
        :student="deleteStudentFormData"
        @close="deleteStudentFormFlag = false"
        @acceptDeleteStudent="deleteStudentVM($event)"
        @updateStudents="updateUsers" 
    />
    <new-student-form :show = "showNewStudentForm" @close="showNewStudentForm = false" @updateStudents="updateUsers"/>
    <student-card  
        v-if="showStudentCardFlag" 
        :currentStudent="currentStudent" 
        @close="() => {showStudentCardFlag = false; fullCardFlag = false; updateUsers(); cleanRoute()}"
        @updateUsers="updateUsers" 
        @fullCard="fullCardFlag = true"
    />
    <div >
        <FileManager 
            v-if="currentFilesSelect" 
            :filesObjects="currentFiles" 
            :marker="selectedFilesMarker" 
            @close="currentFilesSelect = false" 
            @delete="e => deleteFile(e.file, e.marker)"
            @upload="e => uploadFile(e.marker)"    
        />
    </div>
    <!-- <FullStudentCard v-if="false" /> -->
    <!-- <NewFullStudentCard v-if="true" /> -->

    <main v-if="!showStudentCardFlag"  class="main__wrapper">
        <div class="main__section">
            <div class="search-header">
                <div class="search-header__row">
                    <div class="search-header__sub-row">
                        <div class="search-bar">
                            <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
                            <div 
                                class="ml-[60px] flex items-center justify-between mr-[60px] text-[#FFF]">
                                <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="prevPage" >
                                    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.28613" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M11.7139 17L20.821 9.63878L20.821 24.3612L11.7139 17Z" fill="#474849"/>
                                    </svg>
                                </div>
                                <div class="flex mx-[10px]"><input v-model="currentPage" type="number" class="bg-transparent border-[#474849] border-[1px] text-[12px] w-[34px] h-[34px] outline-none px-1 text-center rounded-[6px] mr-[10px]"> <span class="text-[10px] flex justify-center items-center">/</span> <span class="ml-[10px] border-[#474849] flex justify-center items-center bg-transparent border-[1px] w-[34px] h-[34px] text-[12px] outline-none px-1 text-center rounded-[6px] ">{{ maxPage }}</span></div>
                                <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="nextPage">
                                    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.857422" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M23.4287 17L14.3216 9.63878L14.3216 24.3612L23.4287 17Z" fill="#474849"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="w-full flex items-center ">
                            <div class="flex items-center gap-[20px] cursor-pointer">
                                <svg @click="filterFlag = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.713867" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                    <path d="M11.7506 15.0363V9.48662C11.7506 9.30547 11.6787 9.13174 11.5506 9.00365C11.4225 8.87555 11.2487 8.80359 11.0676 8.80359C10.8864 8.80359 10.7127 8.87555 10.5846 9.00365C10.4565 9.13174 10.3845 9.30547 10.3845 9.48662V15.0363C9.79685 15.1868 9.27595 15.5286 8.90397 16.0078C8.53198 16.487 8.33008 17.0764 8.33008 17.6831C8.33008 18.2897 8.53198 18.8791 8.90397 19.3583C9.27595 19.8376 9.79685 20.1793 10.3845 20.3298V24.5134C10.3845 24.6946 10.4565 24.8683 10.5846 24.9964C10.7127 25.1245 10.8864 25.1964 11.0676 25.1964C11.2487 25.1964 11.4225 25.1245 11.5506 24.9964C11.6787 24.8683 11.7506 24.6946 11.7506 24.5134V20.3298C12.3383 20.1793 12.8592 19.8376 13.2312 19.3583C13.6032 18.8791 13.8051 18.2897 13.8051 17.6831C13.8051 17.0764 13.6032 16.487 13.2312 16.0078C12.8592 15.5286 12.3383 15.1868 11.7506 15.0363ZM11.0676 19.0491C10.7974 19.0491 10.5333 18.969 10.3086 18.8189C10.084 18.6688 9.90889 18.4554 9.80549 18.2058C9.7021 17.9562 9.67505 17.6815 9.72776 17.4165C9.78047 17.1516 9.91057 16.9081 10.1016 16.7171C10.2927 16.526 10.5361 16.3959 10.8011 16.3432C11.0661 16.2905 11.3407 16.3176 11.5904 16.421C11.84 16.5244 12.0533 16.6995 12.2034 16.9241C12.3535 17.1488 12.4336 17.4129 12.4336 17.6831C12.4336 18.0454 12.2897 18.3928 12.0335 18.649C11.7773 18.9052 11.4299 19.0491 11.0676 19.0491ZM17.8979 10.9381V9.48662C17.8979 9.30547 17.826 9.13174 17.6979 9.00365C17.5698 8.87555 17.3961 8.80359 17.2149 8.80359C17.0337 8.80359 16.86 8.87555 16.7319 9.00365C16.6038 9.13174 16.5319 9.30547 16.5319 9.48662V10.9381C15.9442 11.0885 15.4233 11.4303 15.0513 11.9096C14.6793 12.3888 14.4774 12.9782 14.4774 13.5848C14.4774 14.1915 14.6793 14.7809 15.0513 15.2601C15.4233 15.7393 15.9442 16.0811 16.5319 16.2316V24.5134C16.5319 24.6946 16.6038 24.8683 16.7319 24.9964C16.86 25.1245 17.0337 25.1964 17.2149 25.1964C17.3961 25.1964 17.5698 25.1245 17.6979 24.9964C17.826 24.8683 17.8979 24.6946 17.8979 24.5134V16.2316C18.4856 16.0811 19.0065 15.7393 19.3785 15.2601C19.7505 14.7809 19.9524 14.1915 19.9524 13.5848C19.9524 12.9782 19.7505 12.3888 19.3785 11.9096C19.0065 11.4303 18.4856 11.0885 17.8979 10.9381ZM17.2149 14.9509C16.9447 14.9509 16.6806 14.8708 16.456 14.7207C16.2313 14.5706 16.0562 14.3572 15.9528 14.1076C15.8494 13.858 15.8224 13.5833 15.8751 13.3183C15.9278 13.0533 16.0579 12.8099 16.2489 12.6189C16.44 12.4278 16.6834 12.2977 16.9484 12.245C17.2134 12.1923 17.4881 12.2194 17.7377 12.3228C17.9873 12.4261 18.2006 12.6012 18.3507 12.8259C18.5009 13.0505 18.581 13.3147 18.581 13.5848C18.581 13.9471 18.437 14.2946 18.1809 14.5508C17.9247 14.807 17.5772 14.9509 17.2149 14.9509ZM26.0944 20.4152C26.0938 19.8095 25.8923 19.2211 25.5215 18.7421C25.1507 18.2631 24.6315 17.9207 24.0453 17.7684V9.48662C24.0453 9.30547 23.9733 9.13174 23.8452 9.00365C23.7171 8.87555 23.5434 8.80359 23.3622 8.80359C23.1811 8.80359 23.0073 8.87555 22.8792 9.00365C22.7511 9.13174 22.6792 9.30547 22.6792 9.48662V17.7684C22.0915 17.9189 21.5706 18.2607 21.1986 18.7399C20.8266 19.2191 20.6247 19.8085 20.6247 20.4152C20.6247 21.0218 20.8266 21.6112 21.1986 22.0905C21.5706 22.5697 22.0915 22.9115 22.6792 23.062V24.5134C22.6792 24.6946 22.7511 24.8683 22.8792 24.9964C23.0073 25.1245 23.1811 25.1964 23.3622 25.1964C23.5434 25.1964 23.7171 25.1245 23.8452 24.9964C23.9733 24.8683 24.0453 24.6946 24.0453 24.5134V23.062C24.6315 22.9097 25.1507 22.5672 25.5215 22.0883C25.8923 21.6093 26.0938 21.0209 26.0944 20.4152ZM23.3622 21.7813C23.092 21.7813 22.8279 21.7011 22.6033 21.551C22.3786 21.4009 22.2035 21.1876 22.1001 20.938C21.9967 20.6884 21.9697 20.4137 22.0224 20.1487C22.0751 19.8837 22.2052 19.6403 22.3963 19.4492C22.5873 19.2582 22.8307 19.1281 23.0957 19.0754C23.3607 19.0227 23.6354 19.0497 23.885 19.1531C24.1346 19.2565 24.348 19.4316 24.4981 19.6562C24.6482 19.8809 24.7283 20.145 24.7283 20.4152C24.7283 20.7775 24.5844 21.125 24.3282 21.3812C24.072 21.6373 23.7245 21.7813 23.3622 21.7813Z" fill="#474849"/>
                                </svg>

                                <svg @click="elementsViewTable = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.42871" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                    <path d="M27.946 7.89294H7.9103C7.42722 7.89294 6.96394 8.08484 6.62235 8.42643C6.28077 8.76801 6.08887 9.2313 6.08887 9.71437V24.2858C6.08887 24.7689 6.28077 25.2322 6.62235 25.5737C6.96394 25.9153 7.42722 26.1072 7.9103 26.1072H27.946C28.4291 26.1072 28.8924 25.9153 29.234 25.5737C29.5755 25.2322 29.7674 24.7689 29.7674 24.2858V9.71437C29.7674 9.2313 29.5755 8.76801 29.234 8.42643C28.8924 8.08484 28.4291 7.89294 27.946 7.89294ZM15.196 18.8215V15.1787H20.6603V18.8215H15.196ZM20.6603 20.6429V24.2858H15.196V20.6429H20.6603ZM7.9103 15.1787H13.3746V18.8215H7.9103V15.1787ZM15.196 13.3572V9.71437H20.6603V13.3572H15.196ZM22.4817 15.1787H27.946V18.8215H22.4817V15.1787ZM27.946 13.3572H22.4817V9.71437H27.946V13.3572ZM13.3746 9.71437V13.3572H7.9103V9.71437H13.3746ZM7.9103 20.6429H13.3746V24.2858H7.9103V20.6429ZM27.946 24.2858H22.4817V20.6429H27.946V24.2858Z" :fill="elementsViewTable ? '#C59014' : '#474849'"/>
                                </svg>

                                <svg @click="elementsViewTable = false" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.14258" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                    <path d="M26.7506 17.9108H8.53627C8.0532 17.9108 7.58991 18.1027 7.24833 18.4443C6.90674 18.7859 6.71484 19.2492 6.71484 19.7322V24.2858C6.71484 24.7689 6.90674 25.2322 7.24833 25.5737C7.58991 25.9153 8.0532 26.1072 8.53627 26.1072H26.7506C27.2336 26.1072 27.6969 25.9153 28.0385 25.5737C28.3801 25.2322 28.572 24.7689 28.572 24.2858V19.7322C28.572 19.2492 28.3801 18.7859 28.0385 18.4443C27.6969 18.1027 27.2336 17.9108 26.7506 17.9108ZM26.7506 24.2858H8.53627V19.7322H26.7506V24.2858ZM26.7506 7.89294H8.53627C8.0532 7.89294 7.58991 8.08484 7.24833 8.42643C6.90674 8.76801 6.71484 9.2313 6.71484 9.71437V14.2679C6.71484 14.751 6.90674 15.2143 7.24833 15.5559C7.58991 15.8975 8.0532 16.0894 8.53627 16.0894H26.7506C27.2336 16.0894 27.6969 15.8975 28.0385 15.5559C28.3801 15.2143 28.572 14.751 28.572 14.2679V9.71437C28.572 9.2313 28.3801 8.76801 28.0385 8.42643C27.6969 8.08484 27.2336 7.89294 26.7506 7.89294ZM26.7506 14.2679H8.53627V9.71437H26.7506V14.2679Z" :fill="!elementsViewTable ? '#C59014' : '#474849'"/>
                                </svg>
                            </div>
                        </div> -->
                    </div>
                    <ButtonComponent @click="() => showNewStudentForm = true" v-if="currentAdminRole != 'supervisor'">Додати</ButtonComponent>
                </div>
            </div>
            <div class="border-b-[1px] border-[#8f8f8f] w-[100%] pb-[12px] mx-auto flex justify-end mt-[16px] mb-[16px]">
                <div class="text-[#8f8f8f] ml-[20px]">
                    <span class="text-[28px] font-semibold">{{ allActiveStudentsCount }}</span> активних
                </div>
                <div class="text-[#8f8f8f] ml-[20px]">
                    <span class="text-[28px] font-semibold">{{ allDebtStudentsCount }}</span> боржників
                </div>
                <div class="text-[#8f8f8f] ml-[20px]">
                    <span class="text-[28px] font-semibold">{{ allArchiveStudentsCount }}</span> архівних
                </div>
            </div>
            <div class="player-groups">
                <TableWrapper>
                    <TableComponent :fullWidth="true">
                        <TableHeader>
                            <TableHeaderRow>
                                <TableHeaderCell
                                    value=""
                                    :width="50"
                                    :textStart="true"
                                />
                                <TableHeaderCell
                                    value="Ім'я"
                                    :width="100"
                                    :textStart="true"
                                />
                                <TableHeaderCell
                                    value="Група"
                                    :width="200"
                                    :textStart="true"
                                />
                                <TableHeaderCell value="Телефон" :width="100" />
                                <TableHeaderCell value="Рейтинг" :width="100" />
                                <TableHeaderCell value="Відвідуваність" :width="100" />
                                <TableHeaderCell value="Матчі" :width="100" />
                                <TableHeaderCell value="Час на полі" :width="100" />
                                <TableHeaderCell value="Договір" :width="100" />
                                <th class="border-b-[1px] border-[#c59014] px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                                    <div @click="currentStatusFlag = !currentStatusFlag" v-if="!showStudentCardFlag && !showNewStudentForm"  class="cursor-pointer text-[#c59014] w-[178px] text-[12px] z-[-40] pr-[26px]">Статус</div>
                                    <div v-if="currentStatusFlag" class="absolute z-[999] top-[40px] right-[-70px] bg-[#252526] border-b-[1px] border-x-[1px] border-[#374957] rounded-b-[10px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.4)] px-2 py-3 flex">
                                        <div class="flex justify-center items-center mx-2">
                                            <input @change="changeStatus('active')" :checked="currentStatuses.includes('active')" type="checkbox" class="mr-[2px] w-[20px] bg-white cursor-pointer">
                                            <div class="bg-[#8FC408] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-white">
                                                <div class="block">
                                                    Активний
                                                </div>
                                            </div>  
                                        </div>
                                        <div class="flex justify-center items-center mx-2">
                                            <input @change="changeStatus('archive')" :checked="currentStatuses.includes('archive')" type="checkbox" class="mr-[2px] cursor-pointer">
                                            <div class="bg-[#D9D9D9] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-[#78797C]">
                                                Архів
                                            </div> 
                                        </div>
                                    </div>
                                </th>
                                <TableHeaderCell value="" :width="100" />
                            </TableHeaderRow>
                        </TableHeader>
                        <TableBody>
                            <new-student-row
                                v-for="student in allStudents" 
                                @openStudentCard="showStudentCard(student)"
                                @deleteStudent="deleteStudentFormData = student; deleteStudentFormFlag = true"
                                @removeStudentFromArchive="deleteStudentFromArchive(student)"
                                @seeContractFile = "seeContractFile(student)"
                                :key="student.student_id" 
                                :student="student"
                            />
                        </TableBody>
                    </TableComponent>
                </TableWrapper>
            </div>
        </div>
    </main>


    <div v-if="currentStatusFlag" @click="currentStatusFlag = false" class="absolute w-full bg-transparent h-full overflow-hidden top-0 left-0 z-0"></div>
    <div v-if="!fullCardFlag && tableViewFlag" class="overflow-y-auto">
        <!-- <menu-bar v-model="searchQuery" v-model:page="currentPage" :maxPage="maxPage" @startFilter="filterAllStudents" @openFilters="" @addStudent="showNewStudentForm = true" />

        <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <div class="text-white">
                <span class="text-[28px] font-semibold">{{ allActiveStudentsCount }}</span> активних
            </div>
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ allDebtStudentsCount }}</span> боржників
            </div>
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ allArchiveStudentsCount }}</span> архівних
            </div>
        </div> -->

        <!-- <keep-alive>
        <div class=" w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
            <table class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-medium text-sm "></th>
                        <th class="px-3 py-2 w-[15%] text-start font-medium text-[12px] ">Ім'я</th>
                        <th class="px-3 py-2 w-[10%] text-start font-medium text-[12px] ">Група</th>
                        <th class="px-3 py-2 w-[10%] text-start font-medium text-[12px] ">Телефон</th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Рейтинг
                            </div>
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium flex justify-end align-middle items-center text-sm">
                            <div class="text-end text-[12px]">
                                Відвідуваність
                            </div>
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Матчі
                            </div>
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Час на полі
                            </div>
                        </th>
                        <th class=" px-3 py-2 cursor-pointer select-none text-end font-medium items-center text-sm">
                            <div class="text-end text-[12px]">
                                Договір
                            </div>
                        </th>
                        <th class="w-[5%]" v-if="screenWidth > 1450"></th>
                        <th class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                            <div @click="currentStatusFlag = !currentStatusFlag" v-if="!showStudentCardFlag && !showNewStudentForm"  class="cursor-pointer w-[178px] text-[12px] z-[-40] pr-[26px]">Статус</div>
                            <div v-if="currentStatusFlag" class="absolute top-[40px] right-[-70px] bg-[#252526] border-b-[1px] border-x-[1px] border-[#374957] rounded-b-[10px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.4)] px-2 py-3 flex">
                                <div class="flex justify-center items-center mx-2">
                                    <input @change="changeStatus('active')" :checked="currentStatuses.includes('active')" type="checkbox" class="mr-[2px] w-[20px] bg-white cursor-pointer">
                                    <div class="bg-[#8FC408] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-white">
                                        <div class="block">
                                            Активний
                                        </div>
                                    </div>  
                                </div>
                                <div class="flex justify-center items-center mx-2">
                                    <input @change="changeStatus('archive')" :checked="currentStatuses.includes('archive')" type="checkbox" class="mr-[2px] cursor-pointer">
                                    <div class="bg-[#D9D9D9] mx-2 h-[18px] flex justify-center items-center rounded-full w-[88px] text-[13px] text-center text-[#78797C]">
                                        Архів
                                    </div> 
                                </div>
                            </div>
                        </th>
                        <th class="px-3 w-[35%] py-2 text-start font-medium text-sm"></th>
                    </tr>
                </thead>
                <tbody v-if="allStudents.length > 0">
                    <new-student-row
                        v-for="student in allStudents" 
                        @openStudentCard="showStudentCard(student)"
                        @deleteStudent="deleteStudentFormData = student; deleteStudentFormFlag = true"
                        @removeStudentFromArchive="deleteStudentFromArchive(student)"
                        @seeContractFile = "seeContractFile(student)"
                        :key="student.student_id" 
                        :student="student"
                    />
                </tbody>
            </table>
        </div>
        </keep-alive> -->

        
        <div v-if="loading" class="z-50 fixed w-full h-full">
            <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#DA4167] border-t-transparent absolute top-[50%] left-[50%] ml-[-160px] mt-[-90px]"></div>
        </div>
        <div class="w-full mt-[14px] flex items-center justify-center" v-else-if="allStudents.length == 0">
            <p class="text-[#A3A3C2] text-[16px]">Гравців не знайдено</p>
        </div>  
    </div>
</template>

<script>
    import { onMounted, ref, computed, watch } from 'vue'
    import { getAllStudents, deleteStudent, getStudentById, getPlayerFullCardByStudentId, getBalanceState, getStudentsCount, getActiveStudentsCount, getDebtStudentsCount, getArchiveStudentsCount, addStudentToArchive, removeStudentFromArchive } from '@/services/apiRequests'
    import { useRoute, useRouter } from 'vue-router'
    import MenuBar from './components/MenuBar.vue'
    import StudentRow from './components/StudentRow.vue'
    import NewStudentForm from './components/NewStudentForm.vue'
    import StudentCard from './components/StudentCard/StudentCard.vue'
    import NewStudentRow from './components/NewStudentRow.vue'
    import DeleteStudentForm from './components/DeleteStudentForm.vue'
    import FullStudentCard from './components/FullStudentCard/FullStudentCard.vue'
    import NewFullStudentCard from './components/NewFullStudentCard/NewFullStudentCard.vue'
    import FileManager from './components/NewFullStudentCard/components/widgets/FileManager.vue'

    async function downloadImageAsBlob(imageUrl) {
        try {
            const response = await fetch(imageUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = await response.blob();
            return blob;
        } catch (error) {
            console.error('Error downloading image:', error);
        }
    }

    export default {
        setup() {
            const route = useRoute()
            const router = useRouter()

            const maybeStudentId = computed(() => {
                return route.params.id
            })

            const allStudents = ref([])
            const showNewStudentForm = ref(false)
            const showStudentCardFlag = ref(false)
            const currentStudent = ref({})
            const deleteStudentFormFlag = ref(false)
            const deleteStudentFormData = ref({})
            const cloneAllStudents = ref([])
            const searchQuery = ref('')
            const currentPage = ref(1)
            const maxPage = ref(1)
            const loading = ref(false)
            const screenWidth = ref(window.innerWidth)

            const tableViewFlag = ref(false)

            const allDebtStudentsCount = ref(0)
            const allActiveStudentsCount = ref(0)
            const allArchiveStudentsCount = ref(0)

            const fullCardFlag = ref(false)

            const balanceVector = ref(null)
            const balanceNewFilter = () => {
                balanceVector.value = balanceVector.value === null ? 'asc' : balanceVector.value === 'asc' ? 'desc' : null
                updateUsers()
                // filterAllStudents()
            }

            watch(searchQuery, () => {
                updateUsers()
            })

            const currentStatuses = ref(['active'])
            const changeStatus = async (status) => {
                if (currentStatuses.value.includes(status)) {
                    currentStatuses.value = currentStatuses.value.filter((item) => item !== status)
                } else {
                    currentStatuses.value.push(status)
                }
                await updateUsers()
                // filterAllStudents()
            }
            const currentStatusFlag = ref(false)

            // const filterAllStudents = () => {
            //     let visibleResult = []
                
            //     if (currentStatuses.value.length === 0) {
            //         visibleResult = []
            //     } else {
            //         currentStatuses.value.forEach((status) => {
            //             if (status === 'active') visibleResult.push(...cloneAllStudents.value.filter((student) => student.status.includes('active') && student.balance >= 0))
            //             if (status === 'archive') visibleResult.push(...cloneAllStudents.value.filter((student) => student.status.includes('archive')))
            //             if (status === 'debtor') visibleResult.push(...cloneAllStudents.value.filter((student) => student.balance < 0))
            //         })
            //     }
               
            //     if (balanceVector.value === 'none') visibleResult = visibleResult
            //     if (balanceVector.value === 'up') visibleResult = visibleResult.sort((a, b) => b.balance - a.balance)
            //     if (balanceVector.value === 'down') visibleResult = visibleResult.sort((a, b) => a.balance - b.balance)

            //     searchQuery.value = searchQuery.value.toLowerCase()
            //     visibleResult = visibleResult.filter((student) => {
            //         return student.name.toLowerCase().includes(searchQuery.value) || student.surname.toLowerCase().includes(searchQuery.value) || student.phone.toLowerCase().includes(searchQuery.value) || student.group_name.toLowerCase().includes(searchQuery.value)
            //     })

            //     console.log('visible result', visibleResult)
            //     allStudents.value = visibleResult
            // }

            const updateUsers = async () => {
                loading.value = true
                allStudents.value = []
                const res = await getAllStudents(20, (currentPage.value - 1) * 20, balanceVector.value, searchQuery.value, null, null, currentStatuses.value)
                allStudents.value = res.data

                allStudents.value.map(async (student) => {
                    student.balance = await getBalanceState(student.balance_id)
                    student.balance = student.balance.toFixed(2)
                    return student
                })
                loading.value = false
            }

            const deleteStudentVM = async (student) => {
                if (student.status.includes('active')) {
                    const res = await addStudentToArchive(student.student_id)
                    updateUsers()
                    deleteStudentFormFlag.value = false
                    await statsUpdate()
                } else if (student.status.includes('archive')) {
                    const res = await deleteStudent(student.student_id)
                    if (res.status === 200) {
                        updateUsers()
                        deleteStudentFormFlag.value = false
                    }
                    await statsUpdate()
                }
            }

            const deleteStudentFromArchive = async (student) => {
                const res = await removeStudentFromArchive(student.student_id)
                updateUsers()
                deleteStudentFormFlag.value = false
                await statsUpdate()
            }

            const statsUpdate = async () => {
                const allDebtStudentsCountRes = await getDebtStudentsCount()
                console.log('allDebtStudentsCountRes --------- ', allDebtStudentsCountRes)
                allDebtStudentsCount.value = allDebtStudentsCountRes
                const allActiveStudentsCountRes = await getActiveStudentsCount()
                allActiveStudentsCount.value = allActiveStudentsCountRes
                const allArchiveStudentsCountRes = await getArchiveStudentsCount()
                allArchiveStudentsCount.value = allArchiveStudentsCountRes
            }

            watch(maybeStudentId, async () => {
                if (maybeStudentId.value) {
                    const student = await getStudentById(maybeStudentId.value)
                    console.log('student333 ---------- ', maybeStudentId.value)
                    if (student) {
                        showStudentCard(student.data.student)
                    }
                }
            })

            onMounted(async () => {
                loading.value = true
                
                if (maybeStudentId.value) {
                    const student = await getStudentById(maybeStudentId.value)
                    console.log('student333 ---------- ', maybeStudentId.value)
                    if (student) {
                        showStudentCard(student.data.student)
                    }
                    tableViewFlag.value = true
                } else {
                    tableViewFlag.value = true
                    await updateUsers()
                    const allUsersCount = await getStudentsCount()
                    console.log('allUsersCount --------- ', allUsersCount)
                    maxPage.value = Math.floor(allUsersCount / 20)
                    cloneAllStudents.value = [...allStudents.value]
                    await statsUpdate()

                    window.addEventListener('resize', () => {
                        screenWidth.value = window.innerWidth
                    })
                }

                loading.value = false
            })

            const showStudentCard = (student) => {
                console.log('student ---------- ', student)
                currentStudent.value = student
                showStudentCardFlag.value = true
            }

            const formatDate = (date) => {
                return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
            }

            watch(currentPage, async () => {
                loading.value = true
                if (maxPage.value <= currentPage.value) currentPage.value = maxPage.value
                await updateUsers()
                loading.value = false
            })

            const cleanRoute = () => {
                //delete params from url
                const userType = localStorage.getItem('userType')
                console.log(userType)

                if (userType == 'doctor') {
                    router.push('/medical-players')
                } else {
                    router.push('/students')
                }

            }

            const currentAdminRole = ref(localStorage.getItem('userType'))
            const apiURL = ref(process.env.VUE_APP_API_URL)


            const seeContractFile = async (student) => {
                console.log('student ---------- ', student)
                const fullCard = await getPlayerFullCardByStudentId(student.student_id)
                if (fullCard.contracts_files) {
                    for (let i = 0; i < fullCard.contracts_files.length; i++) {
                        const blob = await downloadImageAsBlob(apiURL.value + 'static/' + fullCard.contracts_files[i])
                        currentFiles.value.push(new File([blob], fullCard.contracts_files[i].split('.')[0], { type: `image/${fullCard.contracts_files[i].split('.')[1]}` }))
                    }
                }
                currentFilesSelect.value = true
                selectedFilesMarker.value = 'contract'
            }

            const currentFiles = ref([])
            const currentFilesSelect = ref(false)
            const selectedFilesMarker = ref('')

            const prevPage = () => {
                if (currentPage.value > 1) {
                    currentPage.value--
                }
            }

            const nextPage = () => {
                if (currentPage.value < maxPage.value) {
                    currentPage.value++
                }
            }

            return {
                allStudents,
                showNewStudentForm,
                formatDate,
                updateUsers,
                showStudentCard,
                showStudentCardFlag,
                currentStudent,
                deleteStudentFormFlag,
                deleteStudentFormData,
                deleteStudentVM,
                balanceVector,
                balanceNewFilter,
                currentStatuses,
                changeStatus,
                currentStatusFlag,
                searchQuery,
                currentPage,
                maxPage,
                loading,
                screenWidth,
                allDebtStudentsCount,
                allActiveStudentsCount,
                allArchiveStudentsCount,
                deleteStudentFromArchive,
                fullCardFlag,
                cleanRoute,
                tableViewFlag,
                currentAdminRole,
                seeContractFile,
                currentFiles,
                currentFilesSelect,
                selectedFilesMarker,

                prevPage,
                nextPage,
            }
        },

        components: {
            MenuBar,
            StudentRow,
            NewStudentForm,
            StudentCard,
            NewStudentRow,
            DeleteStudentForm,
            FullStudentCard,
            NewFullStudentCard,
            FileManager
        }
    }
</script>

<style lang="scss" scoped>
    .search-bar {
        display: flex;
        gap: 10px;
    }

    .search-header__sub-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .search-header__row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }

    @media screen and (max-width: 1450px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 1150px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }

        .search-header__sub-row {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 890px) {
        .search-header__row {
            flex-direction: column;
            align-items: center;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

</style>